import { useRef } from "react";

import type { MutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { OpportunityListParams } from "../../types";

export type RemoveFromListParams = {
    listParams: OpportunityListParams;
    domains?: readonly string[];
    includeRegionals: boolean;
};

type FetchFn<Params> = (params: Params) => Promise<ReadonlyArray<string>>;

type Options<Params> = Pick<MutationOptions<void, unknown, Params>, "onSuccess"> & {
    fetchDomains?: FetchFn<Params>;
};

export const useRemoveFromListMutation = <Params extends RemoveFromListParams>({
    fetchDomains,
    onSuccess,
}: Options<Params> = {}) => {
    const domains = useRef<readonly string[]>([]);

    return useMutation<void, unknown, Params>({
        mutationFn: ({ listParams, includeRegionals }) => {
            return salesApiService.opportunities.removeOpportunitiesFromList(
                listParams.id,
                domains.current,
                includeRegionals,
            );
        },
        async onMutate(params) {
            domains.current = fetchDomains ? await fetchDomains(params) : (params.domains ?? []);
        },
        onSuccess,
    });
};
